export default __webpack_public_path__ + "static/media/M2.8c958cf1.svg";